export default [{
    id: '_Start',
    from: undefined,
    
    type: 'Audience',
    total: 7000
}, {
    id: '_Goal',
    from: undefined,
    
    type: 'Goal',
    total: 0
}, {
    id: '_Touchpoint1_1',
    from: '_Start',

    type: 'Facebook',
    total: 2500
}, {
    id: '_Touchpoint1_4',
    from: '_Start',

    type: 'Website',
    total: 1500
}, {
    id: '_Touchpoint1_2',
    from: '_Start',

    type: 'Email',
    total: 2500
}, {
    id: '_Touchpoint1_3',
    from: '_Start',

    type: 'OnlineAd',
    total: 50
}, {
    id: '_Goal_2_1',
    from: '_Touchpoint1_3',
    
    type: 'Goal',
    total: 150
}, {
    id: '_Touchpoint2_1',
    from: '_Touchpoint1_1',

    type: 'Website',
    total: 1250
}, {
    id: '_Touchpoint2_3',
    from: '_Touchpoint1_2',

    type: 'OnlineAd',
    total: 1500
}, {
    id: '_Touchpoint2_2',
    from: '_Touchpoint1_2',

    type: 'Website',
    total: 750
}, {
    id: '_Goal_3_1',
    from: '_Touchpoint2_2',
    
    type: 'Goal',
    total: 500
}];